import { function_TODOS_AsistenciaEnLinea_Mensajes_EnviarMensaje, function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeCliente, function_TODOS_AsistenciaEnLinea_Mensajes_ListarDePersona, function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeProveedor } from "neftis7_apicaller/src/funciones/TODOS_AsistenciaEnLinea_Mensajes";
import React, { useEffect, useRef, useState } from "react";

const LVAsistenciaEnLinea = ({ IdCliente, IdProveedor, IdPersona }) => {
  const [mensajes, setMensajes] = useState([]);
  const [nuevoMensaje, setNuevoMensaje] = useState("");
  const [canalSeleccionado, setCanalSeleccionado] = useState("");
  const mensajesRef = useRef(null);

  const detectarCanal = () => {
    if (IdCliente > 0) return "cliente";
    if (IdProveedor > 0) return "proveedor";
    if (IdPersona > 0) return "persona";
    return "";
  };

  useEffect(() => {
    cargarMensajes();
    setCanalSeleccionado(detectarCanal());
    const interval = setInterval(() => cargarMensajes(), 5000);
    return () => clearInterval(interval);
  }, []);

  const cargarMensajes = async () => {
    try {
      let respuesta
      if (IdCliente > 0) {
        respuesta = await function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeCliente(IdCliente);
      }
      if (IdProveedor > 0) {
        respuesta = await function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeProveedor(IdProveedor);
      }
      if (IdPersona > 0) {
        respuesta = await function_TODOS_AsistenciaEnLinea_Mensajes_ListarDePersona(IdPersona);
      }
      setMensajes(respuesta.data);
      mensajesRef.current?.scrollTo(0, mensajesRef.current.scrollHeight);
    } catch (err) {
      console.error("Error cargando mensajes:", err);
    }
  };

  const enviarMensaje = async () => {
    if (!nuevoMensaje.trim()) return;
    try {      
      const canal = detectarCanal();
      
      const Mensaje = {
        CodigoCompania: localStorage.getItem("CodigoCompania"),
        CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
        CodigoPlanta: localStorage.getItem("CodigoPlanta"),
        IdCliente: IdCliente,
        IdProveedor: IdProveedor,
        IdPersona: IdPersona,
        Canal: canal,
        Texto: nuevoMensaje,
        EsGeneracionAutomatica: false
      }

      await function_TODOS_AsistenciaEnLinea_Mensajes_EnviarMensaje(Mensaje)
      setNuevoMensaje("");
      cargarMensajes();
    } catch (err) {
      console.error("Error enviando mensaje:", err);
    }
  };

  return (
    <div style={{
      width: 350,
      height: 525,
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 12,
      background: '#fefefe',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      overflow: 'hidden'
    }}>
      <div style={{ backgroundColor: '#007bff', color: 'white', padding: '12px 20px', fontWeight: 'bold' }}>
        💬 Asistencia en línea
      </div>

      <div ref={mensajesRef} style={{ flex: 1, overflowY: 'auto', padding: 15, backgroundColor: '#f7f9fb' }}>
        {mensajes.map((msg, idx) => (
          <div
            key={idx}
            style={{
              display: 'flex',
              justifyContent: msg.Remitente === canalSeleccionado ? 'flex-end' : 'flex-start',
              marginBottom: 10
            }}
          >
            <div
              style={{
                maxWidth: '70%',
                padding: '8px 12px',
                borderRadius: 12,
                backgroundColor: msg.Remitente === canalSeleccionado ? '#007bff' : '#e5e5ea',
                color: msg.Remitente === canalSeleccionado ? 'white' : 'black',
                fontSize: '0.9rem'
              }}
            >
              {msg.Texto}
            </div>
          </div>
        ))}
      </div>

      <div style={{ padding: 10, borderTop: '1px solid #ddd', backgroundColor: 'white' }}>
        <input
          type="text"
          value={nuevoMensaje}
          placeholder="Escribí tu mensaje..."
          onChange={e => setNuevoMensaje(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && enviarMensaje()}
          style={{
            width: '100%',
            padding: '8px 12px',
            borderRadius: 8,
            border: '1px solid #ccc',
            outline: 'none'
          }}
        />
      </div>
    </div>
  );
};

export default LVAsistenciaEnLinea;
